import { scrollToTop } from '@efdigital/ll-xceed-v2/utils/application/scroll.ts';
import type Owner from '@ember/owner';
import type Transition from '@ember/routing/transition';

/** `coaching.coach.sessions.past` → `coaching.coach.sessions`. */
function parentRouteName(routeName: string | undefined): string | undefined {
  return routeName?.split('.').slice(0, -1).join('.');
}

export function initialize(owner: Owner) {
  const router = owner.lookup('service:router');
  router.on('routeDidChange', (transition: Transition) => {
    const from = transition.from?.name;
    const to = transition.to?.name;

    if (from === to) {
      return;
    }

    // Switching between sibling views of the page you're already on — session
    // upcoming / action-required / history, or a coachee's upcoming / past /
    // canceled links, for example — should leave you where you are. Scrolling
    // to the top there throws away your place in whatever you were reading,
    // and the switcher itself is often off-screen.
    if (parentRouteName(from) === parentRouteName(to)) {
      return;
    }

    scrollToTop();
  });
}

export default {
  initialize,
};
